import ko from 'knockout';
import kx from '@/gr/common/knockout/extended';
import { AggregateMetric, RawMetric } from '@/apps/timeSeriesViewer';
import { ColumnDto, FacetKeyDto } from '@/repositories';

export class InputDataDefinitionChooserState {
  search = ko.observable<string>('');
  tabs = ko.observableArray<Tab>([]);
  selectedTab = ko.observable<Tab | null>(null);
  resultCount = ko.observable<number | null>(null);
  isLoading = ko.observable<boolean>(false);
}

export class Tab {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly availableGroupingFacets: KnockoutObservableArray<FacetKeyDto>,
    readonly selectedGroupingFacets: KnockoutObservable<FacetKeyDto[] | null>,
    readonly columns: KnockoutObservableArray<ColumnDto>,
    readonly rows: KnockoutObservableArray<Row>,
    readonly isVisible: KnockoutObservable<boolean>
  ) {}
}

export class Row {
  constructor(
    readonly name: string,
    readonly cells: Cell[],
    readonly children: Row[],
    readonly isExpanded: KnockoutObservable<boolean>
  ) {}
}

export class Cell {
  constructor(
    readonly column: ColumnDto,
    readonly inputDataDefinitionId: RawMetric | AggregateMetric,
    readonly isSelected: kx.ReadOnlyObservable<boolean>,
    public score: number
  ) {}
}

export class Facet {
  constructor(
    readonly id: string,
    readonly name: string
  ) {}

  values!: FacetValue[];
}

export class FacetValue {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly recordCount: number,
    readonly facet: Facet
  ) {}
}
